import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Business } from '../../ts/interfaces/business'

interface State {
  business: Business[]
}

export const initialState: State = {
  business: []
}

export const business = createSlice({
  name: 'business',
  initialState,
  reducers: {
    setBusinessState: (state, action: PayloadAction<Partial<State>>) => {
      return { ...state, ...action.payload }
    },
    clearBusinessState: () => {
      return initialState
    }
  }
})

export const { setBusinessState, clearBusinessState } = business.actions

export default business.reducer
